import React from 'react'
import { AutoCompleterV3, AutoCompleterConfig } from '../../../components/_WMS/AutoCompleterV3'
import { Supplier } from '../../../interfaces/Supplier/Supplier'
import { ComponentProps } from '../../../components/_WMS/FilterComponent/types'
import { createFilterValueWithDisplay } from '../../../types/filters'
import { ApiConfig } from '../../../config/api'

const supplierConfig: AutoCompleterConfig<Supplier> = {
  searchEndpoint: `${ApiConfig.SupplierApi}/search`,
  searchParam: 'q',
  keyField: 'supplierId',
  displayField: 'supplierName',
  minSearchLength: 3,
  debounceMs: 300,
  pageSize: 10
}

export const SupplierAutoCompleter: React.FC<ComponentProps> = ({
  value,
  onChange,
  fullWidth = true,
  transformForBackend,
  transformForDisplay
}) => {
  const [selectedSupplier, setSelectedSupplier] = React.useState<Supplier | null>(null)

  // Sincronizar con el valor externo cuando cambie
  React.useEffect(() => {
    if (value && value !== selectedSupplier?.supplierId.toString()) {
      // Si hay un valor pero no coincide con el seleccionado, limpiar
      setSelectedSupplier(null)
    }
  }, [value, selectedSupplier])

  const handleSupplierChange = (supplier: Supplier | null) => {
    setSelectedSupplier(supplier)

    // Si hay transformadores disponibles, usar el enfoque JSON para compatibilidad con FilterComponent
    // Si no, usar el valor simple (para casos donde se use fuera de FilterComponent)
    let eventValue = ''
    if (supplier) {
      if (transformForBackend && transformForDisplay) {
        // Usar función tipada para FilterComponent
        eventValue = createFilterValueWithDisplay(
          supplier.supplierId,
          `${supplier.supplierName} (${supplier.rutDniSupplier})`
        )
      } else {
        // Usar valor simple para otros casos
        eventValue = supplier.supplierId.toString()
      }
    }

    const syntheticEvent = {
      target: {
        value: eventValue,
        name: 'supplierId'
      }
    } as React.ChangeEvent<HTMLInputElement>

    onChange(syntheticEvent)
  }

  const renderOption = (supplier: Supplier) => (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <div style={{ fontWeight: 'bold' }}>{supplier.supplierName}</div>
      <div style={{ fontSize: '0.875rem', color: '#666' }}>
        RUT/DNI: {supplier.rutDniSupplier}
      </div>
    </div>
  )

  const renderValue = (supplier: Supplier) =>
    `${supplier.supplierName} (${supplier.rutDniSupplier})`

  return (
    <AutoCompleterV3<Supplier>
      config={supplierConfig}
      value={selectedSupplier}
      onChange={handleSupplierChange}
      placeholder="Buscar proveedor..."
      renderOption={renderOption}
      renderValue={renderValue}
      width={fullWidth ? "100%" : 300}
    />
  )
}
